/** Archive and restore for customers, vendors, products and bank accounts: hidden from pickers for new work, kept in history. */
import { api, useAction } from '../lib/api';
import { Badge, Button } from './ui';

export function ArchivedBadge({ at }: { at: string | null }) {
  return at ? <Badge className="ml-2 align-middle">Archived</Badge> : null;
}

/** `onDone` runs after the change, e.g. to close the dialog that shows the old state. */
export function ArchiveButton({ path, archived, noun, size = 'md', onDone }: { path: string; archived: boolean; noun: string; size?: 'sm' | 'md'; onDone?: () => void }) {
  const run = useAction(() => api(path, { method: 'PATCH', body: { archived: !archived } }), {
    success: archived ? `${noun} restored` : `${noun} archived. It stays in your history but leaves the pickers.`,
  });
  return (
    <Button size={size} variant="ghost" loading={run.isPending} onClick={() => run.mutate(undefined, { onSuccess: onDone })}>
      {archived ? 'Restore' : 'Archive'}
    </Button>
  );
}

/** "Show archived (n)" for a list page. Nothing to show when nothing is archived. */
export function ShowArchived({ count, value, onChange }: { count: number; value: boolean; onChange: (v: boolean) => void }) {
  if (!count) return null;
  return (
    <label className="flex cursor-pointer items-center gap-1.5 text-[12.5px] whitespace-nowrap text-muted select-none">
      <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} className="accent-[var(--color-brand)]" />
      Show archived ({count})
    </label>
  );
}
